export default __webpack_public_path__ + "static/media/LINKUSD.607a69a6.svg";